<template>
  <div class="row">
    <div class="col-12">
      <div v-html="text" class="accordion-text"></div>
    </div>

    <div class="col-12 mt-3 block-text">
      <div class="mb-1" v-for="(accordion, index) in accordions" :key="accordion.id">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0">{{ accordion.titolo }}</h6>
          <b-button
            v-b-toggle="`accordion-${id}-${index}`"
            variant="outline-secondary"
            class="rounded-circle accordion-toggle"
          >
            <b-icon icon="chevron-down" :scale="0.9"></b-icon>
          </b-button>
        </div>
        <hr />
        <b-collapse :id="`accordion-${id}-${index}`" :accordion="'accordion-group-' + id">
          <div class="p-3">
            <p v-html="accordion.contenuto"></p>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccordionGroup",
  props: {
    header: Object,
    accordions: Array,
    text: String,
    id: Number,
  },
};
</script>

<style scoped lang="scss">
::v-deep .accordion-text {
  & p > img {
    width: 100%;
  }
}

.accordion-toggle {
  height: 32px;
  width: 32px;
  padding: 0.2rem 0 0 0;
  line-height: 0;
}
</style>
